function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Snow"
}, /*#__PURE__*/React.createElement("title", null, "VF_snow_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M258.7 59.1c-15.2-13-34.6-20-54.6-19.8-2.5 0-5 .1-7.5.3C180.5 15.6 151.5 0 119.1 0 95.6 0 73.3 8.1 56.4 22.7 47.9 30 41 38.9 36.1 48.9 31.6 58 29 67.9 28.4 78c-3.8 2.3-7.4 5-10.7 8.1C6.5 96.4 0 111.1 0 126.5c.1 16.3 7.4 31.7 19.8 42.2 11.9 10.1 27 15.6 42.6 15.5h141.7c20 .2 39.4-6.9 54.6-19.8 15.7-13.6 24.7-32.8 24.7-52.7s-8.9-39-24.7-52.6zm-54.6 96.8H62.4c-18.8 0-34-13.2-34-29.4 0-15.3 13.5-27.9 30.8-29.3-1.6-4.8-2.4-9.8-2.4-14.9 0-29.8 27.9-54 62.4-54 30.6 0 56.1 19.1 61.3 44.3 7.4-3.4 15.5-5.1 23.7-5.1 28.2 0 51 19.8 51 44.2s-22.9 44.2-51.1 44.2z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-.408 .15)",
  cx: "77.9",
  cy: "212.6",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "113.4",
  cy: "255.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "42.5",
  cy: "255.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "184.3",
  cy: "255.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.8 198.4c-7.8 0-14.2 4.4-14.2 14.2s6.4 14.2 14.2 14.2 14.2-4.4 14.2-14.2-6.3-14.2-14.2-14.2zM219.7 198.4c-7.8 0-14.2 4.4-14.2 14.2s6.4 14.2 14.2 14.2 14.2-4.4 14.2-14.2-6.4-14.2-14.2-14.2z"
}))));